<template>
  <div class="del">
    <modal :id="modalId">
      <h3>Delete {{ itemType }}</h3>
      <div class="warning-msg">
        <p>
          Are you sure want to delete
          <strong>
            {{ itemName }}
          </strong>
          {{ itemType }}?
        </p>
      </div>
      <div class="d-flex justify-content-between">
        <b-button variant="danger btn-round-fill " @click="handleDelete">
          Yes! Delete
        </b-button>
        <b-button class="btn-simple" @click="handleCancel()">
          No! back
        </b-button>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/common/modal";
export default {
  components: {
    Modal
  },
  props: {
    modalId: {
      type: String,
      default: "modal"
    },
    itemType: {
      type: String,
      default: "type"
    },
    itemName: {
      type: String,
      default: "name"
    },
    itemId: {
      type: String,
      default: null
    }
  },
  data() {
    return {};
  },
  methods: {
    handleDelete() {
      this.$emit("delete-item", this.itemId);
    },
    handleCancel() {
      this.$bvModal.hide(this.modalId);
    }
  }
};
</script>

<style lang="scss" scoped>
.del {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}
</style>
